import { useState, useEffect, useRef } from "react";
import { Button } from "@aidron/aidron-ds";
import PropTypes from 'prop-types';

export function Carousel({ slideNumber, children, onSlide }) {
  const carouselRef = useRef(null);
  const slideNumberArray = Array.from({ length: slideNumber }, (_, i) => i);

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    const handleSlid = (e) => onSlide?.(e.to);

    el.addEventListener('slid.bs.carousel', handleSlid);
    return () => el.removeEventListener('slid.bs.carousel', handleSlid);
  }, [onSlide]);

  return (
    <div
      id="chartModalCarousel"
      className="carousel carousel-dark"
      data-bs-interval="false"
      ref={carouselRef}
    >
      <div className="carousel-indicators">
        {slideNumberArray.map((index) => (
          <button
            type="button"
            data-bs-target="#chartModalCarousel"
            data-bs-slide-to={index}
            className={`${index === 0 ? "active disabled-carousel-indicators" : "disabled-carousel-indicators"} mx-1`}
            key={index}
          />
        ))}
      </div>

      <div className="carousel-inner mt-3 mt-lg-0 overflow-visible">{children}</div>

      <div
        className="carousel-control-prev border-0 controls-style"
        type="button"
        data-bs-target="#chartModalCarousel"
        data-bs-slide="prev"
        style={{ width: '12px', left: '0', top: '105%', transform: 'translateY(-50%)', zIndex: 1 }}>
        <Button label="" onClick={() => {}} type="outlined" icon="chevron-left" size="sm" disabled={slideNumber === 1} />
        <span className="visually-hidden">Previous</span>
      </div>

      <div
        className="carousel-control-next border-0 controls-style"
        type="button"
        data-bs-target="#chartModalCarousel"
        data-bs-slide="next"
        style={{ width: '12px', right: '0', top: '105%', transform: 'translateY(-50%)', zIndex: 1 }}>
        <Button label="" onClick={() => {}} type="outlined" icon="chevron-right" size="sm" disabled={slideNumber === 1} />
        <span className="visually-hidden">Next</span>
      </div>
    </div>
  );
}

Carousel.propTypes = {
  slideNumber: PropTypes.number,
  children: PropTypes.node,
  onSlide: PropTypes.func
}